import React, { useCallback, useRef, useState } from "react";
import Breadcrumbs from 'components/Common/Breadcrumb';
import MetaTags from 'react-meta-tags';
import Select from "react-select"
import { Link } from "react-router-dom";
import {
  Container,
  Card,
  CardBody,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  FormGroup,
  Row,
  UncontrolledDropdown,
} from "reactstrap";
import {
  DATE_RANGE_OPTIONS,
  createOption,
} from "components/Common/DateRangePicker"
import ToolkitProvider, {
  Search,
  CSVExport,
} from "react-bootstrap-table2-toolkit"

import { AppConfiguration } from "config";
import BootstrapTable from "react-bootstrap-table-next";
import { useDispatch, useSelector } from "react-redux";
import { SfDollarStringFormatter, capitalizeFirstLetter, capitalizeWord, checkUrlFiltersPresent, dollarFormatWithTwoDecimalPlaces, getCurrentBrandFromLocalStorage, getIANATimezoneStringForAbbreviation, getLeadRedundStatus, getOptionFromValueForSelectBox, getParsedFilters, getPrimaryButtonClass, getPrimaryTextClass, printNameOrEmail, sortStringAsFloat, forColumnHeaderWrapper, nullHandlerCustomizeColumns } from "helpers/sf_utils";
import { useEffect } from "react";
import { getLeads, updateLead } from "store/leads/actions";
import { getLeadTypeById, LEADS_FILTERED_COLUMNS_OBJECTS, optionGroupType, REPORTING_TIMEZONE, REQUIRED_FEATURE_FLAGS, PRODUCT_TYPE_IDS, TABLE_COLMN_NAMES, LEADS_STATUS_OPTIONS, LEADS_CALLS_STATUS_DEFAULT_VALUE, convertStringifiedNullToNull, PAGES_FOR_DRAGGABLE_CUSTOMIZE_COLUMN, sortColumnsByOrder, TOOLTIPS, LEADS_BACKEND_SORTABLE_COLUMNS, DISPOSITION_EDITOR_CLASS, DISPOSITION_EDITOR_SELECTOR } from "helpers/sf_constants";
import UserStyle from '../Admin/Users/Users.module.css';
import { format, isAfter, isBefore } from "date-fns";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import SfLoadingSkeleton from "components/Common/Loadings/SfLoadingSkeleton";
import { utcToZonedTime } from "date-fns-tz";
import _ from "lodash";
import { defaultFormatter } from "pages/Admin/Users/UserComponents/UserList/Formatters";
import { useMemo } from "react";
import CustomizeColumnsModal from "pages/Campaign/CommonComponents/CustomizeColumnsModals/CustomizeColumnsModal";
import { getLeadStickyColumns, updateLeadStickyColumns } from "store/user_column_preference/lead-sticky-columns/actions";
import useFeatureFlags from "hooks/useFeatureFlags";
import { getColumnDataFieldByMatchingPreference } from "helpers/user_column_preference_helper";
import LeadFilterModal from "./LeadFilterModal";
import ModifyLoadingIcon from "components/Common/Loadings/ModifyLoadingIcon";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { bsh_getFilters, bsh_setFilters, STORAGE_KEY } from "helpers/sf_browser_storage_helper";
import { getCustomizeColumnsOrder } from "store/customize-columns-order/actions";
import useAccountCampaigns from "hooks/useAccountCampaigns";
import useUrlFilter from "hooks/useUrlFilter";
import CustomExportCSVButton from "components/Common/CustomExportCSVButton";
import { exportLeadsOnEmail } from "store/export-email/actions";
import { customSortCaret } from "helpers/bootstrap_table_helper";
import { getCostFromLeadReceipts } from "components/Common/LeadDetail/LeadSnapshot";
import useReceiptTypes from "hooks/useReceiptTypes";
import useNewBrandUI from 'hooks/useNewBrandUI';
import useBrandList from "hooks/useBrandList";
import { getCampaignOptions } from "helpers/sf_dashboard_helper";
import useSingleActionDispatcher from "hooks/useSingleActionDispatcher";
import { generateSICColumns } from "helpers/sf_leads_calls_helper";
import { isBenepathBrand } from "config";
import LeadNoteModal from "components/Common/Notes/LeadNoteModal";
import { createLeadNotes, getLeadNotesSuccess } from "store/notes/lead_notes/actions";
import { extractNotesFromLeadsOrCalls, getNotesCountByLeadId, openNotesModal } from "helpers/sf_lead_notes_helper";
import Skeleton from "react-loading-skeleton";
import OffsetPagination from "components/Common/OffsetPagination";

const { ExportCSVButton } = CSVExport
let dateFilter = null;

const LEADS_FILTERS = {
  FIRST_NAME: 'first_name',
  FIRST_NAME_VALUE: 'first_name_value',
  LAST_NAME: 'last_name',
  LAST_NAME_VALUE: 'last_name_value',
  PHONE_NUM: 'phone_num',
  PHONE_NUM_VALUE: 'phone_num_value',
  EMAIL: 'email',
  EMAIL_VALUE: 'email_value',
  STATE: 'state',
  STATE_VALUE: 'state_value',
  CAMPAIGN_NAME: 'campaign_name',
  CAMPAIGN_NAME_VALUE: 'campaign_name_value',
  LEAD_TYPE: 'lead_type',
  LEAD_TYPE_VALUE: 'lead_type_value',
  STATUS: 'status',
  STATUS_VALUE: 'status_value',
  RECEIVED: 'received',
  RECEIVED_VALUE: 'received_value',
  RECEIVED_VALUE_LABEL: 'received_value_label',
  BRAND_NAME: 'brand_name',
  BRAND_NAME_VALUE: 'brand_name_value'
}

const DEFAULT_SORT_COLUMN = 'created_at';
const DEFAULT_SORT_DIRECTION = 'desc';

const Leads = () => {

  const dispatch = useDispatch();
  const history = useHistory();
  const getNewUrl = useUrlFilter();
  const urlQueryParams = window.location.href;

  const [isFeatureFlagActive] = useFeatureFlags();
  const {
    error,
    get_leads_loading,
    leadsData,
    current_account,
    current_brand, last_page_fetched,
    total_number_of_pages,
    user_column_preference_lead,
    user_column_preference_lead_loading,
    leads_customize_columns_order,
    export_email_loading,
    has_next_page,
    has_lookahead_pages,
    lead_notes,
    lead_notes_loading
  } = useSelector(state => ({
    error: state.Leads.error,
    get_leads_loading: state.Leads.get_leads_loading,
    leadsData: state.Leads.leads,
    current_account: state.accounts.current_account,
    current_brand: state.Brands.current_brand,
    last_page_fetched: state.Leads.last_page_fetched,
    total_number_of_pages: state.Leads.total_number_of_pages,
    user_column_preference_lead: state.UserLeadColumnPreference.user_column_preference_lead,
    user_column_preference_lead_loading: state.UserLeadColumnPreference.loading,
    leads_customize_columns_order: state.CustomizeColumnsOrder.leads_customize_columns_order,
    export_email_loading: state.ExportEmail.lead_loading,
    has_next_page: state.Leads.has_next_page,
    has_lookahead_pages: state.Leads.has_lookahead_pages,
    lead_notes: state.leadNotesReducer.lead_notes,
    lead_notes_loading: state.leadNotesReducer.lead_notes_loading,
  }));

  const [_unscoped_account_campaigns, account_campaigns, hasActiveCommercialCampaign] = useAccountCampaigns();

  const showSICColumns = useMemo(() => {
    return isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_ENABLE_SIC_CODE_TARGETING)
  }, [isFeatureFlagActive])

  const showLeadAndCallsNotes = useMemo(() => {
    return isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_SHOW_LEAD_AND_CALLS_NOTES)
  }, [isFeatureFlagActive])
  const shouldUseOffsetPagination = useMemo(() => (
    isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_OFFSET_PAGINATION_APPLICATION)
  ), [isFeatureFlagActive])

  const backendSortingEnabled = useMemo(
    () => isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_BACKEND_COLUMN_SORTING),
    [isFeatureFlagActive],
  );
  const [sortState, setSortState] = useState({ column: DEFAULT_SORT_COLUMN, direction: DEFAULT_SORT_DIRECTION });

  const handleTableChange = useCallback((type, { sortField, sortOrder }) => {
    if (type !== 'sort' || !backendSortingEnabled) return;
    if (sortField === sortState.column && sortOrder === sortState.direction) return;
    setSortState({ column: sortField, direction: sortOrder });
  }, [backendSortingEnabled, sortState]);

  const { isReceiptTypeIdDebitActual } = useReceiptTypes()
  const [selectedDateRange, setSelectedDateRange] = useState(createOption(
    DATE_RANGE_OPTIONS.ALL_TIME,
    new Date(),
    getIANATimezoneStringForAbbreviation(current_account?.timezone) || REPORTING_TIMEZONE)
  );
  const dropdownPressTargetRef = useRef(null);
  const [selectedLeadGroup, setSelectedLeadGroup] = useState(optionGroupType[0].options[0]);
  const [filteredLeads, setfilteredLeads] = useState([]);
  const [loadingRowIndex, setLoadingRowIndex] = useState(null);
  const [loadingCell, setLoadingCell] = useState({ row: null, col: null });
  const [nameInput, setNameInput] = useState('');
  const [isEditingStatus, setIsEditingStatus] = useState({});
  const [editIconRow, setEditIconRow] = useState(); // State variable to show/hide
  const [selectedStatus, setSelectedStatus] = useState(getOptionFromValueForSelectBox(LEADS_STATUS_OPTIONS, LEADS_CALLS_STATUS_DEFAULT_VALUE.RECEIVED_NOT_WORKED_YET));
  const [customizeColumnsOrder, setCustomizeColumnsOrder] = useState({})

  const [isActiveFilterModal, setIsActiveFilterModal] = useState(false);
  const [customizeColumnsModal, setCustomizeColumnsModal] = useState({
    isActiveModal: false,
    columns: [],
  })
  const [searchTerm, setSearchTerm] = useState('');
  const [filterModal, setFilterModal] = useState({

    first_name: bsh_getFilters(STORAGE_KEY.FILTERS.LEADS, LEADS_FILTERS.FIRST_NAME) || false,
    first_name_value: bsh_getFilters(STORAGE_KEY.FILTERS.LEADS, LEADS_FILTERS.FIRST_NAME_VALUE) || "",

    last_name: bsh_getFilters(STORAGE_KEY.FILTERS.LEADS, LEADS_FILTERS.LAST_NAME) || false,
    last_name_value: bsh_getFilters(STORAGE_KEY.FILTERS.LEADS, LEADS_FILTERS.LAST_NAME_VALUE) || "",

    phone_num: bsh_getFilters(STORAGE_KEY.FILTERS.LEADS, LEADS_FILTERS.PHONE_NUM) || false,
    phone_num_value: bsh_getFilters(STORAGE_KEY.FILTERS.LEADS, LEADS_FILTERS.PHONE_NUM_VALUE) || "",

    email: bsh_getFilters(STORAGE_KEY.FILTERS.LEADS, LEADS_FILTERS.EMAIL) || false,
    email_value: bsh_getFilters(STORAGE_KEY.FILTERS.LEADS, LEADS_FILTERS.EMAIL_VALUE) || "",

    state: bsh_getFilters(STORAGE_KEY.FILTERS.LEADS, LEADS_FILTERS.STATE) || false,
    state_value: bsh_getFilters(STORAGE_KEY.FILTERS.LEADS, LEADS_FILTERS.STATE_VALUE) || null,

    campaign_name: bsh_getFilters(STORAGE_KEY.FILTERS.LEADS, LEADS_FILTERS.CAMPAIGN_NAME) || false,
    campaign_name_value: bsh_getFilters(STORAGE_KEY.FILTERS.LEADS, LEADS_FILTERS.CAMPAIGN_NAME_VALUE) || "",

    lead_type: bsh_getFilters(STORAGE_KEY.FILTERS.LEADS, LEADS_FILTERS.LEAD_TYPE) || false,
    lead_type_value: bsh_getFilters(STORAGE_KEY.FILTERS.LEADS, LEADS_FILTERS.LEAD_TYPE_VALUE) || "",

    status: bsh_getFilters(STORAGE_KEY.FILTERS.LEADS, LEADS_FILTERS.STATUS) || false,
    status_value: bsh_getFilters(STORAGE_KEY.FILTERS.LEADS, LEADS_FILTERS.STATUS_VALUE) || null,

    received: bsh_getFilters(STORAGE_KEY.FILTERS.LEADS, LEADS_FILTERS.RECEIVED) || false,
    received_value: bsh_getFilters(STORAGE_KEY.FILTERS.LEADS, LEADS_FILTERS.RECEIVED_VALUE) || "",
    received_value_label: bsh_getFilters(STORAGE_KEY.FILTERS.LEADS, LEADS_FILTERS.RECEIVED_VALUE_LABEL) || "",

    brand_name: bsh_getFilters(STORAGE_KEY.FILTERS.LEADS, LEADS_FILTERS.BRAND_NAME) || false,
    brand_name_value: bsh_getFilters(STORAGE_KEY.FILTERS.LEADS, LEADS_FILTERS.BRAND_NAME_VALUE) || "",
  });

  const [filteredColumns, setFilteredColumns] = useState([]);
  const [activeFilteredColumnsState, setActiveFilteredColumnsState] = useState(null);
  const [brandsOptions, setBrandsOptions] = useState([]);
  const { brandList } = useBrandList(true)
  const show_rtb_brand_ui_changes = useNewBrandUI();
  const [leadNoteModal, setLeadNoteModal] = useState({
    action: false,
    lead_id: null,
    notes: [],
  });

  useEffect(() => {
    setBrandsOptions(brandList)
  }, [brandList]);

  useEffect(() => {
    setfilteredLeads(leadsData)
    // Extract notes from leads data and dispatch to store
    if (isBenepathBrand && leadsData && leadsData.length > 0) {
      const extractedNotes = extractNotesFromLeadsOrCalls(leadsData);
      if (extractedNotes.notes.length > 0 || extractedNotes.processedLeadIds.length > 0) {
        dispatch(getLeadNotesSuccess(extractedNotes));
      }
    }
  }, [leadsData, dispatch]);

  const updatedBrandId = () => {
    let brand_id = show_rtb_brand_ui_changes ? null : current_brand?.id || getCurrentBrandFromLocalStorage()?.id;
    return brand_id
  }

  const campaignOptions = useMemo(() => {
    const campaigns = account_campaigns?.filter(campaign => campaign.product_type_id === PRODUCT_TYPE_IDS.LEADS)
    const campaignOpts = getCampaignOptions(campaigns, show_rtb_brand_ui_changes)
    return campaignOpts;

  }, [leadsData, account_campaigns, show_rtb_brand_ui_changes]);

  const buildLeadsListQueryParams = (pageNumber = 1, filterModal = null) => {
    const dateRangeValue = _.cloneDeep(selectedDateRange.value);
    const params = {
      page_number: pageNumber,
      brand_id: updatedBrandId(),
    };
    if (dateRangeValue?.startDate) {
      params.start_date = dateRangeValue.startDate.toISOString();
    }
    if (dateRangeValue?.endDate) {
      params.end_date = dateRangeValue.endDate.toISOString();
    }
    if (filterModal) {
      const filterModalData = convertStringifiedNullToNull(filterModal);
      params.filters = JSON.stringify(filterModalData || {});
    }
    if (backendSortingEnabled) {
      params.sort_column = LEADS_BACKEND_SORTABLE_COLUMNS.includes(sortState.column)
        ? sortState.column : DEFAULT_SORT_COLUMN;
      params.sort_direction = sortState.direction || DEFAULT_SORT_DIRECTION;
    }
    return params;
  };

  const fetchLeadsPage = (pageNumber = 1, filterModal = null) => {
    const queryParams = buildLeadsListQueryParams(pageNumber, filterModal);
    const newUrl = getNewUrl(queryParams, REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_URL_FILTERS_ON_LEADS)
    if (newUrl != "") {
      history.push(newUrl);
    }
    !get_leads_loading && dispatch(getLeads({
      queryParams: queryParams,
      replaceResults: shouldUseOffsetPagination,
      useCache: shouldUseOffsetPagination,
    }, true));
  }

  // Mirror of getCallsExportFilters on the Calls page: nothing checked -> no filters; when a box
  // is checked, prefer the cleaned activeFilteredColumnsState but fall back to the raw filterModal
  // so a filter that only lives in filterModal isn't silently dropped from the export.
  const getLeadsExportFilters = () => {
    if (filterCheckedCount <= 0) {
      return null;
    }

    return Object.keys(activeFilteredColumnsState || {}).length > 0
      ? activeFilteredColumnsState
      : filterModal;
  }

  useEffect(() => {
    //Filter out leadsData json which doesnt have searchTerm
    if (searchTerm) {
      const fltrdLeads = leadsData.filter((lead) => {
        return lead.lead_detail.first_name.toLowerCase().includes(searchTerm.toLowerCase()) || lead.lead_detail.last_name.toLowerCase().includes(searchTerm.toLowerCase()) || lead.lead_detail.email.toLowerCase().includes(searchTerm.toLowerCase()) || lead.lead_detail.phone.toLowerCase().includes(searchTerm.toLowerCase()) || lead.lead_detail.state.toLowerCase().includes(searchTerm.toLowerCase())
      })
      setfilteredLeads(fltrdLeads)
    } else {
      setfilteredLeads(leadsData)
    }
  }, [searchTerm]);

  const { SearchBar } = Search

  useEffect(() => {
    isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_CUSTOMIZE_COLUMNS_ORDERING_ON_LEADS_PAGE) &&
      dispatch(getCustomizeColumnsOrder({ page_name: PAGES_FOR_DRAGGABLE_CUSTOMIZE_COLUMN.LEADS }))
  }, [])

  useSingleActionDispatcher(getLeadStickyColumns());

  useEffect(() => {
    selectedDateRange && dateFilter && dateFilter(selectedDateRange.value);
  }, [selectedDateRange]);

  // For Name Formatter
  function nameFormatter(_cellContent, row) {
    const name = printNameOrEmail(row?.lead_detail?.first_name, row?.lead_detail?.last_name, null, '-- --')
    return (
      <Link to={{
        pathname: `/leads/${row?.id}`
      }}
        className='text-sfblue'
      >
        {name}
      </Link>
    )
  }

  // Notes formatter for Leads page (Benepath only)
  const notesFormatter = (cell, row, rowIndex, lead_notes_loading) => {
    if (!isBenepathBrand) return null;
    return (
      <div className="d-flex align-items-center">
        {(lead_notes_loading ? <Skeleton width={60} height={20} /> :
          <a onClick={() => onClickOpenNotes(row?.id)} className='text-sfblue'>
            {`(${getNotesCountByLeadId(lead_notes, row?.id)})` + (getNotesCountByLeadId(lead_notes, row?.id) !== 1 ? " Notes" : " Note")}
          </a>)}
      </div>
    );
  }

  const onClickOpenNotes = (lead_id) => {
    if (!isBenepathBrand) return;
    openNotesModal(lead_notes, lead_id, setLeadNoteModal);
  }

  const onSubmitLeadNoteModal = (newNote) => {
    if (!isBenepathBrand) return;
    dispatch(createLeadNotes({
      lead_id: newNote.lead_id,
      lead_note: {
        text: newNote.text
      }
    }));
  }

  const onCloseLeadNoteModal = () => {
    setLeadNoteModal({
      action: false,
      lead_id: null,
      notes: [],
    });
  }
  const onFilterByDateFunc = (filterVal, data) => {
    if (!!filterVal == false) {
      return data;
    }

    return data.filter((leads_date) => {
      const date = new Date(leads_date);
      try {
        if (filterVal.startDate && isBefore(date, filterVal.startDate)) {
          return false;
        }

        if (filterVal.endDate && isAfter(date, filterVal.endDate)) {
          return false;
        }
        return true;
      } catch (error) {
        return false;
      }
    });
  };

  const onClickSaveDisposition = (row, _nameInput) => {
    dispatch(updateLead({ id: row?.id, disposition: selectedStatus?.value }))
    setfilteredLeads(prevLeads => prevLeads.map(lead => 
      lead.id === row?.id 
        ? { ...lead, disposition: selectedStatus?.value } 
        : lead
    ));
    setIsEditingStatus(null)
  }
  // For created at Formatter
  function LeadsTimeFormatter(cellContent, row) {
    return (
      <span>{cellContent && format(utcToZonedTime(cellContent, getIANATimezoneStringForAbbreviation(REPORTING_TIMEZONE)), 'MM/dd/yyyy hh:mm aa')}</span>
    )
  }


  // react-select opens its menu on mousedown, and when the menu does not fit below the control
  // it animate-scrolls the page to bring the menu into view. The mouseup then lands on a
  // different element, so the browser dispatches the click on a common ancestor well outside
  // the disposition cell. Remembering where the press started keeps that scroll from reading as
  // an outside click, which used to close the editor the instant it was opened on short windows.
  const rememberDropdownPressTarget = (e) => {
    dropdownPressTargetRef.current = e.target;
  };

  //For disabling dropdown on clicking outside
  const closeDropdown = (e) => {
    if (!isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_ALLOW_DROPDOWN_CLOSE)) {
      return
    }

    const pressTarget = dropdownPressTargetRef.current || e.target;
    dropdownPressTargetRef.current = null;

    // Presses inside the editor (toggle, react-select menu, Save/Cancel) are handled by the
    // disposition column's own click handler.
    if (pressTarget?.closest?.(DISPOSITION_EDITOR_SELECTOR)) {
      return
    }

    setIsEditingStatus(null);
  };

  // For phone number Formatter
  function phoneNumberFormatter(cellContent, row) {
    return (
      <span>{cellContent ? cellContent.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3') : "--"}</span>
    )
  }

  // ----------------- Filters Start ---------------------


  //For Filter OnSubmit
  const onSubmitOpenFilterModal = (values) => {
    setFilterModal({ ...filterModal, ...values })
    bsh_setFilters(STORAGE_KEY.FILTERS.LEADS, LEADS_FILTERS.FIRST_NAME, values?.first_name)
    bsh_setFilters(STORAGE_KEY.FILTERS.LEADS, LEADS_FILTERS.FIRST_NAME_VALUE, values?.first_name_value)
    bsh_setFilters(STORAGE_KEY.FILTERS.LEADS, LEADS_FILTERS.LAST_NAME, values?.last_name)
    bsh_setFilters(STORAGE_KEY.FILTERS.LEADS, LEADS_FILTERS.LAST_NAME_VALUE, values?.last_name_value)
    bsh_setFilters(STORAGE_KEY.FILTERS.LEADS, LEADS_FILTERS.PHONE_NUM, values?.phone_num)
    bsh_setFilters(STORAGE_KEY.FILTERS.LEADS, LEADS_FILTERS.PHONE_NUM_VALUE, values?.phone_num_value)
    bsh_setFilters(STORAGE_KEY.FILTERS.LEADS, LEADS_FILTERS.EMAIL, values?.email)
    bsh_setFilters(STORAGE_KEY.FILTERS.LEADS, LEADS_FILTERS.EMAIL_VALUE, values?.email_value)
    bsh_setFilters(STORAGE_KEY.FILTERS.LEADS, LEADS_FILTERS.STATE, values?.state)
    bsh_setFilters(STORAGE_KEY.FILTERS.LEADS, LEADS_FILTERS.STATE_VALUE, values?.state_value)
    bsh_setFilters(STORAGE_KEY.FILTERS.LEADS, LEADS_FILTERS.CAMPAIGN_NAME, values?.campaign_name)
    bsh_setFilters(STORAGE_KEY.FILTERS.LEADS, LEADS_FILTERS.CAMPAIGN_NAME_VALUE, values?.campaign_name_value)
    bsh_setFilters(STORAGE_KEY.FILTERS.LEADS, LEADS_FILTERS.LEAD_TYPE, values?.lead_type)
    bsh_setFilters(STORAGE_KEY.FILTERS.LEADS, LEADS_FILTERS.LEAD_TYPE_VALUE, values?.lead_type_value)
    bsh_setFilters(STORAGE_KEY.FILTERS.LEADS, LEADS_FILTERS.STATUS, values?.status)
    bsh_setFilters(STORAGE_KEY.FILTERS.LEADS, LEADS_FILTERS.STATUS_VALUE, values?.status_value)
    bsh_setFilters(STORAGE_KEY.FILTERS.LEADS, LEADS_FILTERS.RECEIVED, values?.received)
    bsh_setFilters(STORAGE_KEY.FILTERS.LEADS, LEADS_FILTERS.RECEIVED_VALUE, values?.received_value)
    bsh_setFilters(STORAGE_KEY.FILTERS.LEADS, LEADS_FILTERS.RECEIVED_VALUE_LABEL, values?.received_value_labels)
    bsh_setFilters(STORAGE_KEY.FILTERS.LEADS, LEADS_FILTERS.BRAND_NAME, values?.brand_name)
    bsh_setFilters(STORAGE_KEY.FILTERS.LEADS, LEADS_FILTERS.BRAND_NAME_VALUE, values?.brand_name_value)

    setIsActiveFilterModal(false)
  }

  //For Filter Modal Open 
  const onClickOpenFilterModal = () => {
    setIsActiveFilterModal(true)
  }
  //For Filter Modal Close 
  const onCloseFilterModal = () => {
    setIsActiveFilterModal(false);
  }

  const onClickRemoveFilter = (fieldName) => {
    setFilterModal({ ...filterModal, [fieldName]: !fieldName, [fieldName + '_value']: "" })
    bsh_setFilters(STORAGE_KEY.FILTERS.LEADS, fieldName, !fieldName)
    bsh_setFilters(STORAGE_KEY.FILTERS.LEADS, fieldName + '_value', "")
    setFilteredColumns([])
  }

  const filterCount = useMemo(() => {
    return filteredColumns?.length
  }, [filteredColumns])

  const filterCheckedCount = useMemo(() => {
    let count = 0
    for (const k in filterModal) {
      if (filterModal[k] === true && k !== 'isActiveModal') {
        count += 1
      }
    }
    return count
  }, [filterModal])

  useEffect(() => {
    let isUpdateStates = false;
    let isFilteredColumns = [];
    const activeFilteredColumns = {}

    if (filterModal?.first_name && filterModal?.first_name_value) {
      isUpdateStates = true;
      isFilteredColumns.push({ ...LEADS_FILTERED_COLUMNS_OBJECTS.FIRST_NAME, value: filterModal?.first_name_value })
      activeFilteredColumns.first_name = filterModal?.first_name;
      activeFilteredColumns.first_name_value = filterModal?.first_name_value;
    }

    if (filterModal?.last_name && filterModal?.last_name_value) {
      isUpdateStates = true;
      isFilteredColumns.push({ ...LEADS_FILTERED_COLUMNS_OBJECTS.LAST_NAME, value: filterModal?.last_name_value })
      activeFilteredColumns.last_name = filterModal?.last_name;
      activeFilteredColumns.last_name_value = filterModal?.last_name_value;
    }

    if (filterModal?.email && filterModal?.email_value) {
      isUpdateStates = true;
      isFilteredColumns.push({ ...LEADS_FILTERED_COLUMNS_OBJECTS.EMAIL, value: filterModal?.email_value })
      activeFilteredColumns.email = filterModal?.email;
      activeFilteredColumns.email_value = filterModal?.email_value;
    }

    if (filterModal?.phone_num && filterModal?.phone_num_value) {
      isUpdateStates = true;
      isFilteredColumns.push({ ...LEADS_FILTERED_COLUMNS_OBJECTS.PHONE, value: filterModal?.phone_num_value })
      activeFilteredColumns.phone_num = filterModal?.phone_num;
      activeFilteredColumns.phone_num_value = filterModal?.phone_num_value;
    }

    if (filterModal?.received && JSON.parse(filterModal?.received)) {
      isUpdateStates = true;
      if (JSON.parse(filterModal?.received_value)?.startDate == null
        && JSON.parse(filterModal?.received_value)?.endDate == null) {
        isFilteredColumns.push({
          ...LEADS_FILTERED_COLUMNS_OBJECTS.RECEIVED,
          value: 'All time'
        })

      } else {
        isFilteredColumns.push({ ...LEADS_FILTERED_COLUMNS_OBJECTS.RECEIVED, value: format(utcToZonedTime(JSON.parse(filterModal?.received_value)?.startDate, REPORTING_TIMEZONE), 'MM/d/yyyy') + " - " + format(utcToZonedTime(JSON.parse(filterModal?.received_value)?.endDate, REPORTING_TIMEZONE), 'MM/d/yyyy') })
      }
      activeFilteredColumns.received = filterModal?.received;
      activeFilteredColumns.received_value = filterModal?.received_value;
      activeFilteredColumns.received_value_label = filterModal?.received_value_label;
    }

    if (filterModal?.campaign_name && JSON.parse(filterModal?.campaign_name_value)) {
      isUpdateStates = true;
      const campaign_array = JSON.parse(filterModal?.campaign_name_value)
      isFilteredColumns.push({ ...LEADS_FILTERED_COLUMNS_OBJECTS.CAMPAIGN_NAME, value: campaign_array.map(el => el.label).join(', ') })
      activeFilteredColumns.campaign_name = filterModal?.campaign_name;
      activeFilteredColumns.campaign_name_value = filterModal?.campaign_name_value;
    }

    if (filterModal?.state && JSON.parse(filterModal?.state_value)) {
      isUpdateStates = true;
      const state_array = JSON.parse(filterModal?.state_value)
      state_array.length !== 0 && isFilteredColumns.push({ ...LEADS_FILTERED_COLUMNS_OBJECTS.STATE, value: state_array.map(el => el.value).join(', ') })
      activeFilteredColumns.state = filterModal?.state;
      activeFilteredColumns.state_value = filterModal?.state_value;
    }

    if (filterModal?.lead_type && JSON.parse(filterModal?.lead_type_value)) {
      isUpdateStates = true;
      const lead_type_array = JSON.parse(filterModal?.lead_type_value)
      lead_type_array.length !== 0 && isFilteredColumns.push({ ...LEADS_FILTERED_COLUMNS_OBJECTS.LEAD_TYPE, value: lead_type_array.map(el => el.label).join(', ') })
      activeFilteredColumns.lead_type = filterModal?.lead_type;
      activeFilteredColumns.lead_type_value = filterModal?.lead_type_value;
    }

    if (filterModal?.status && JSON.parse(filterModal?.status_value)) {
      isUpdateStates = true;
      const status_array = JSON.parse(filterModal?.status_value)
      status_array.length !== 0 && isFilteredColumns.push({ ...LEADS_FILTERED_COLUMNS_OBJECTS.STATUS, value: status_array.map(el => el.value).join(', ') })
      activeFilteredColumns.status = filterModal?.status;
      activeFilteredColumns.status_value = filterModal?.status_value;
    }
    if (filterModal?.brand_name && JSON.parse(filterModal?.brand_name_value)) {
      isUpdateStates = true;
      const brand_array = JSON.parse(filterModal?.brand_name_value)
      isFilteredColumns.push({ ...LEADS_FILTERED_COLUMNS_OBJECTS.BRAND_NAME, value: brand_array.map(el => el.label).join(', ') })
      activeFilteredColumns.brand_name = filterModal?.brand_name;
      activeFilteredColumns.brand_name_value = filterModal?.brand_name_value;
    }

    setActiveFilteredColumnsState(activeFilteredColumns);
    if (isUpdateStates) {
      fetchLeadsPage(1, activeFilteredColumns)
      setFilteredColumns(isFilteredColumns);
      return
    }
    fetchLeadsPage()
    setFilteredColumns([]);
  }, [filterModal, current_brand, show_rtb_brand_ui_changes, sortState])

  // ----------------- Filters End ---------------------

  // ----------------- Customize Columns Start ---------------------

  //For CustomizeColumns Modal Close
  const onClickOpenCustomizeColumnsModal = () => {
    let userColumnPreferenceFields = [];
    if (isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_USER_COLUMN_PREFERENCE)) {
      userColumnPreferenceFields = getColumnDataFieldByMatchingPreference(leadsColumns, hide_user_column_preference, 'columnName');
    }

    let sortedCustomizeColumns;
    if (!isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_CUSTOMIZE_COLUMNS_ORDERING_ON_CALLS_PAGE)) {
      sortedCustomizeColumns = userColumnPreferenceFields;
    }
    else {
      sortedCustomizeColumns = sortColumnsByOrder(userColumnPreferenceFields, customizeColumnsOrder);
    }
    setCustomizeColumnsModal({
      ...customizeColumnsModal,
      isActiveModal: true,
      columns: sortedCustomizeColumns,
    })
  }

  //For CustomizeColumns Modal Close
  const onCloseCustomizeColumnsModal = () => {
    setCustomizeColumnsModal({
      ...customizeColumnsModal,
      isActiveModal: false,
      columns: [],
    })
  }

  //For CustomizeColumns OnSubmit
  const onSubmitCustomizeColumnsModal = values => {
    if (isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_USER_COLUMN_PREFERENCE)) {
      const userColumnPreference = getColumnDataFieldByMatchingPreference(values, hide_user_column_preference, 'columnName');
      const userColumnPreferenceData = userColumnPreference.reduce((a, c) => Object.assign(a, { [c.columnName]: c.hidden }), {});
      const userColumnPreferenceFinalData = {
        user_column_preference_lead: { ...userColumnPreferenceData, id: user_column_preference_lead?.id }
      }
      dispatch(updateLeadStickyColumns(userColumnPreferenceFinalData));
    }
    onCloseCustomizeColumnsModal()
  }

  const handleColumns = singe_obj => {
    setCustomizeColumnsModal(preState => {
      const tempPrevState = preState?.columns.map(prev =>
        prev.text === singe_obj.text && prev.dataField === singe_obj.dataField
          ? { ...singe_obj, hidden: !singe_obj.hidden }
          : prev
      )
      return { ...preState, columns: tempPrevState }
    })
  }

  let _hide_user_column_preference = _.cloneDeep(user_column_preference_lead)
  for (const key in user_column_preference_lead) {
    _hide_user_column_preference[key] = user_column_preference_lead == null ? false : user_column_preference_lead[key]
  }

  const hide_user_column_preference = useMemo(() => {
    const updated_hide_col = { ..._hide_user_column_preference }
    if (current_account) {
      if (!(isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_USER_COLUMN_PREFERENCE))) {
        updated_hide_col['lead_name'] = false;
        updated_hide_col['lead_email'] = false;
        updated_hide_col['lead_phone'] = false;
        updated_hide_col['lead_state'] = false;
        updated_hide_col['lead_city'] = false;
        updated_hide_col['lead_address'] = false;
        updated_hide_col['lead_type'] = false;
        updated_hide_col['lead_created_at'] = false;
        updated_hide_col['lead_brand'] = false;
        updated_hide_col['lead_campaign'] = false;
        updated_hide_col['lead_status'] = false;
      }

      if (!(isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_STATUS_COLUMN_IN_LEADS_AND_CALLS))) {
        updated_hide_col['lead_status'] = null;
      }

      if (current_account?.enterprise) {
        updated_hide_col['lead_cost'] = null;
        updated_hide_col['lead_refund_status'] = null;
      }

      if (!isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_ENABLE_GROUP_HEALTH_LEAD_TYPE)) {
        updated_hide_col['lead_num_employees'] = null;
      }

      if (!showSICColumns) {
        updated_hide_col['lead_sic4'] = null;
        updated_hide_col['lead_naics'] = null;
        updated_hide_col['lead_business_desc'] = null;
        updated_hide_col['lead_business_name'] = null;
      } else if (!hasActiveCommercialCampaign) {
        updated_hide_col['lead_sic4'] = null;
        updated_hide_col['lead_naics'] = null;
        updated_hide_col['lead_business_desc'] = null;
      }

      // Hide lead_notes column if not Benepath brand
      if (!isBenepathBrand) {
        updated_hide_col['lead_notes'] = null;
      }

    }
    return updated_hide_col;

  }, [current_account, _hide_user_column_preference, user_column_preference_lead])

  // ----------------- Customize Columns Start ---------------------
  const backendSortableSet = backendSortingEnabled ? new Set(LEADS_BACKEND_SORTABLE_COLUMNS) : null;
  const colSort = (dataField, clientSort) => backendSortableSet ? backendSortableSet.has(dataField) : clientSort;

  const leadsColumns = [{
    dataField: 'name',
    text: 'Name',
    headerFormatter: forColumnHeaderWrapper,
    sort: colSort('name', true),
    formatter: nameFormatter,
    hidden: (hide_user_column_preference?.['lead_name'] === null) ? true : (hide_user_column_preference?.['lead_name']),
    sortFunc: (_a, _b, order, _dataField, rowA, rowB) => { //Sorting first name and last name
      const nameA = rowA?.lead_detail?.first_name;
      const nameB = rowB?.lead_detail?.first_name;
      const lastNameA = rowA?.lead_detail?.last_name;
      const lastNameB = rowB?.lead_detail?.last_name;

      if (order === 'asc') {
        if (nameA === nameB) {
          return lastNameA?.localeCompare(lastNameB);
        }
        return nameA?.localeCompare(nameB);
      } else {
        if (nameA === nameB) {
          return lastNameB?.localeCompare(lastNameA);
        }
        return nameB?.localeCompare(nameA);
      }
    },
    csvFormatter: (_cellContent, row) => (row?.lead_detail?.first_name + " " + row?.lead_detail?.last_name),
    columnName: 'lead_name'
  },
  {
    dataField: 'price',
    hidden: (hide_user_column_preference?.['lead_cost'] === null) ? true : (hide_user_column_preference?.['lead_cost']),
    text: 'Cost',
    headerFormatter: forColumnHeaderWrapper,
    sort: colSort('price', true),
    sortFunc: backendSortingEnabled ? undefined : sortStringAsFloat,
    formatter: (cell) => dollarFormatWithTwoDecimalPlaces(cell),
    csvFormatter: (cell) => SfDollarStringFormatter(cell),
    columnName: 'lead_cost'
  },
  {
    dataField: 'refund_status',
    hidden: (hide_user_column_preference?.['lead_refund_status'] === null) ? true : (hide_user_column_preference?.['lead_refund_status']),
    text: 'Return',
    headerFormatter: forColumnHeaderWrapper,
    sort: colSort('refund_status', true),
    formatter: (cell) => cell || '--',
    csvFormatter: (cell) => cell || '--',
    columnName: 'lead_refund_status'
  },
  {
    dataField: 'lead_detail.phone',
    hidden: (hide_user_column_preference?.['lead_phone'] === null) ? true : (hide_user_column_preference?.['lead_phone']),
    text: 'Phone',
    headerFormatter: forColumnHeaderWrapper,
    sort: colSort('lead_detail.phone', true),
    formatter: phoneNumberFormatter,
    columnName: 'lead_phone'
  }, {
    dataField: 'lead_detail.email',
    hidden: (hide_user_column_preference?.['lead_email'] === null) ? true : (hide_user_column_preference?.['lead_email']),
    text: 'Email',
    headerFormatter: forColumnHeaderWrapper,
    sort: colSort('lead_detail.email', true),
    columnName: 'lead_email'
  }, {
    dataField: 'lead_detail.state',
    hidden: (hide_user_column_preference?.['lead_email'] === null) ? true : (hide_user_column_preference?.['lead_state']),
    text: 'State',
    headerFormatter: forColumnHeaderWrapper,
    sort: colSort('lead_detail.state', true),
    columnName: 'lead_state'
  }, {
    dataField: 'lead_detail.city',
    hidden: nullHandlerCustomizeColumns(hide_user_column_preference?.['lead_city']),
    text: 'City',
    headerFormatter: forColumnHeaderWrapper,
    sort: colSort('lead_detail.city', true),
    formatter: defaultFormatter,
    csvFormatter: (_cellContent, row) => (_cellContent || "--"),
    columnName: 'lead_city'
  }, {
    dataField: 'lead_detail.address',
    hidden: nullHandlerCustomizeColumns(hide_user_column_preference?.['lead_address']),
    text: 'Address',
    headerFormatter: forColumnHeaderWrapper,
    sort: colSort('lead_detail.address', true),
    formatter: defaultFormatter,
    csvFormatter: (_cellContent, row) => (_cellContent || "--"),
    columnName: 'lead_address'
  }, {
    dataField: 'lead_detail.num_employees',
    hidden: nullHandlerCustomizeColumns(hide_user_column_preference?.['lead_num_employees']),
    text: 'Number of Employees',
    headerFormatter: forColumnHeaderWrapper,
    sort: colSort('lead_detail.num_employees', true),
    formatter: (cellContent, row) => {
      const numEmployees = cellContent || row?.lead_business_entities?.[0]?.num_full_time_employees;
      return defaultFormatter(numEmployees);
    },
    csvFormatter: (cellContent, row) => {
      const numEmployees = cellContent || row?.lead_business_entities?.[0]?.num_full_time_employees;
      return numEmployees || "--";
    },
    columnName: 'lead_num_employees'
  },
  {
    dataField: 'campaign.brand.name',
    hidden: (hide_user_column_preference?.['lead_brand'] === null) ? true : (hide_user_column_preference?.['lead_brand']),
    text: 'Brand',
    headerFormatter: forColumnHeaderWrapper,
    sort: colSort('campaign.brand.name', true),
    columnName: 'lead_brand'
  },
  {
    dataField: 'campaign.name',
    hidden: (hide_user_column_preference?.['lead_campaign_name'] === null) ? true : (hide_user_column_preference?.['lead_campaign_name']),
    text: 'Campaign Name',
    headerFormatter: forColumnHeaderWrapper,
    sort: colSort('campaign.name', true),
    formatter: (cellContent, row) => {
      return (
        <Link className="text-sfblue" to={`/campaigns/${row?.campaign?.id}/summary`}>
          {cellContent}
        </Link>
      )
    },
    columnName: 'lead_campaign_name'
  },
  {
    dataField: 'lead_type_id',
    hidden: (hide_user_column_preference?.['lead_type'] === null) ? true : (hide_user_column_preference?.['lead_type']),
    text: 'Type',
    headerFormatter: forColumnHeaderWrapper,
    sort: colSort('lead_type_id', true),
    formatter: (cellContent) => capitalizeWord(getLeadTypeById(cellContent)?.name || ''),
    csvFormatter: (cellContent, row, rowIndex) => (cellContent ? capitalizeWord(getLeadTypeById(cellContent)?.name || "") : ""),
    columnName: 'lead_type'
  }, {
    dataField: 'disposition',
    hidden: (hide_user_column_preference?.['lead_status'] === null) ? true : (hide_user_column_preference?.['lead_status']),
    text: 'Disposition',
    sort: colSort('disposition', true),
    hasInfoTooltip: true,
    tooltipDescription: 'Allows you to categorize the lead based on where you are in the sales process with the prospect.',
    headerFormatter: forColumnHeaderWrapper,
    columnName: 'lead_status',
    events: {
      onKeyDown: (e, row, rowIndex) => {
        if (e.code == 'Enter') {
          setLoadingRowIndex(rowIndex);
          onClickSaveDisposition(row, nameInput)
        }
      },
      onClick: (e, _column, _columnIndex, row, rowIndex) => {
        setLoadingCell({ row: rowIndex, column: TABLE_COLMN_NAMES.STATUS });
        setLoadingRowIndex(rowIndex);
        if (e.target.name === 'saveName') {
          onClickSaveDisposition(row, nameInput)
        } else if (e.target.name === 'resetName') {
          setIsEditingStatus(null);
        } else {
          if (isEditingStatus?.row != rowIndex) {
            setSelectedStatus(getOptionFromValueForSelectBox(LEADS_STATUS_OPTIONS, row?.disposition) || LEADS_STATUS_OPTIONS[0]);
          }
          setIsEditingStatus({ row: rowIndex });
        }
      }
    },
    formatter: (cellContent, row, rowIndex) => {
      return (
        <div className={`d-flex ${DISPOSITION_EDITOR_CLASS}`}>
          <UncontrolledDropdown
            isOpen={((isEditingStatus != null) && (isEditingStatus.row == rowIndex))}>
            <DropdownToggle href="#" className='card-drop fsnormal' tag="i">
              {
                (get_leads_loading === true)
                  && (loadingCell.row === rowIndex)
                  && (loadingCell.col === TABLE_COLMN_NAMES.STATUS) ? (<ModifyLoadingIcon color="secondary" />) : (
                  <>
                    <span className='text-black'>{row?.disposition || LEADS_STATUS_OPTIONS[0]?.value}</span>
                    <span className={`ms-1 font-size-16 ${(rowIndex === editIconRow) ? '' : 'edit-hover-class'}`}>
                      <a><i className="mdi mdi-pencil text-success" /></a>
                    </span>
                  </>
                )
              }
            </DropdownToggle>
            <DropdownMenu className="dropdown-menu-start">
              <DropdownItem className="font-weight-semibold">Disposition</DropdownItem>
              <DropdownItem divider />
              <DropdownItem text style={{ width: '365px' }}>
                <div className="d-flex flex-column">
                  <div className="form-group">
                    <Select
                      name="lead_status"
                      onChange={(e) => {
                        setSelectedStatus(e);
                      }}
                      value={selectedStatus}
                      options={LEADS_STATUS_OPTIONS}
                      classNamePrefix="select2-selection sf_dropdown_popup"
                      placeholder=""
                      // Render the option list in a <body> portal so it draws over the card
                      // instead of being clipped by the table's 50vh scroll container.
                      menuPortalTarget={document.body}
                      menuPosition="fixed"
                      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                    />
                  </div>
                  <div className="ms-auto mt-2">
                    <button className={`btn btn-sm ${getPrimaryButtonClass()} mx-1`} name="saveName" type="submit">Save</button>
                    <button className="btn btn-sm btn-light mx-1" name="resetName" type="reset">Cancel</button>
                  </div>
                </div>
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </div>
      )
    }
  }, {
    dataField: 'created_at',
    hidden: (hide_user_column_preference?.['lead_created_at'] === null) ? true : (hide_user_column_preference?.['lead_created_at']),
    text: 'Received',
    headerFormatter: forColumnHeaderWrapper,
    sort: colSort('created_at', true),
    formatter: LeadsTimeFormatter,
    csvFormatter: (cellContent) => (cellContent && format(utcToZonedTime(cellContent, getIANATimezoneStringForAbbreviation(REPORTING_TIMEZONE)), 'MM/dd/yyyy hh:mm aa')),
    filter: textFilter({
      style: {
        display: 'none',
      },
      getFilter: (filter) => {
        dateFilter = filter;
      },
      onFilter: onFilterByDateFunc,

    }),
    columnName: 'lead_created_at'
  },
  ...(isBenepathBrand && showLeadAndCallsNotes ? [{
    dataField: 'lead_notes',
    text: 'Notes',
    headerFormatter: forColumnHeaderWrapper,
    sort: false,
    formatter: notesFormatter,
    hasInfoTooltip: true,
    tooltipDescription: TOOLTIPS.CAMPAIGNS.GENERIC.LEAD_AND_CALL_NOTES,
    formatExtraData: lead_notes_loading,
    csvExport: false,
    hidden: (hide_user_column_preference?.['lead_notes'] === null) ? true : (hide_user_column_preference?.['lead_notes']),
    columnName: 'lead_notes'
  }] : []),
  ...(generateSICColumns('lead', hide_user_column_preference))
  ];

  const rowEvents = {
    onMouseEnter: (_e, _column, rowIndex) => {
      setEditIconRow(rowIndex);
    },
    onMouseLeave: (_e, _column, _rowIndex) => {
      setEditIconRow(null);
    },

  };

  useEffect(() => {
    if (checkUrlFiltersPresent(urlQueryParams)) {
      const parsedFilters = getParsedFilters(urlQueryParams)
      parsedFilters.brand_id = updatedBrandId()
      setFilterModal({ ...filterModal, ...JSON.parse(parsedFilters?.filters || '{}') })
      !get_leads_loading && dispatch(getLeads({
        queryParams: parsedFilters,
        replaceResults: shouldUseOffsetPagination,
        useCache: shouldUseOffsetPagination,
      }, true));
    }
    // Run only on initial mount so URL hydration happens once.
    // Including urlQueryParams causes re-runs when history/location changes and triggers duplicate fetches.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const sortedColumns = useMemo(() => {
    if (!isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_CUSTOMIZE_COLUMNS_ORDERING_ON_LEADS_PAGE)) {
      return leadsColumns
    }
    else {
      return sortColumnsByOrder(leadsColumns, customizeColumnsOrder);
    }
  }, [filteredLeads, leadsColumns, customizeColumnsOrder, customizeColumnsModal])

  useEffect(() => {
    if (leads_customize_columns_order) {
      const columns_to_include = [
        "lead_name",
        "lead_cost",
        "lead_refund_status",
        "lead_phone",
        "lead_email",
        "lead_state",
        "lead_city",
        "lead_address",
        "lead_num_employees",
        "lead_brand",
        "lead_campaign_name",
        "lead_status",
        "lead_type",
        ...(isBenepathBrand ? ["lead_notes"] : []),
        "lead_created_at",
        "lead_sic4",
        "lead_naics",
        "lead_business_desc",
        "lead_business_name"
      ];

      const filteredCustomizeColumns = {};
      Object.keys(leads_customize_columns_order).forEach(key => {
        if (columns_to_include.includes(key)) {
          filteredCustomizeColumns[key] = leads_customize_columns_order[key];
        }
      });

      setCustomizeColumnsOrder(filteredCustomizeColumns);
    }
  }, [leads_customize_columns_order]);

  const handleAnalyticsDataExport = (e) => {
    e.preventDefault();

    const exportFilters = getLeadsExportFilters();
    const newUrl = getNewUrl({ page_number: 1 }, REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_URL_FILTERS_ON_LEADS)
    if (newUrl != "") {
      const parsedFilters = getParsedFilters(urlQueryParams)
      parsedFilters.brand_id = updatedBrandId()
      if (exportFilters) {
        const filterModalData = convertStringifiedNullToNull(exportFilters);
        parsedFilters.filters = JSON.stringify(filterModalData || {});
      }
      if (backendSortingEnabled) {
        parsedFilters.sort_column = LEADS_BACKEND_SORTABLE_COLUMNS.includes(sortState.column)
          ? sortState.column : DEFAULT_SORT_COLUMN;
        parsedFilters.sort_direction = sortState.direction || DEFAULT_SORT_DIRECTION;
      }
      dispatch(exportLeadsOnEmail({ queryParams: parsedFilters }, true))
    }
    else {
      const exportParams = buildLeadsListQueryParams(1, exportFilters);
      dispatch(exportLeadsOnEmail({ queryParams: exportParams }, true))
    }
  }

  return (
    <>
      <div onMouseDownCapture={rememberDropdownPressTarget} onClick={closeDropdown} className="page-content" id="page-content-wrapper">
        <MetaTags>
          <title>Leads | {AppConfiguration.WEBSITE}</title>
        </MetaTags>
        <Container fluid>
          <div className="d-flex justify-content-between">
            <Breadcrumbs breadcrumbItem="Leads" copyUrl={true} />
            {isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_USER_COLUMN_PREFERENCE) ? (<div className="float-end">
              <button className="d-flex align-items-center text-sfblue bg-transparent rounded border-0" type="button" onClick={onClickOpenCustomizeColumnsModal} >
                <i className="bx bx-columns font-size-18 me-2 bx-sm" />
                Customize Columns
              </button>
            </div>) : null}
          </div>
          {/* Action Modals */}
          <CustomizeColumnsModal
            pageName={PAGES_FOR_DRAGGABLE_CUSTOMIZE_COLUMN.LEADS}
            modalState={customizeColumnsModal}
            setModalState={setCustomizeColumnsModal}
            onSubmitModalState={onSubmitCustomizeColumnsModal}
            handleColumns={handleColumns}
            onClickModalClose={onCloseCustomizeColumnsModal}
            dragndropFeatureFlag={REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_CUSTOMIZE_COLUMNS_ORDERING_ON_LEADS_PAGE}
          />
          <LeadFilterModal
            isActive={isActiveFilterModal}
            modalState={filterModal}
            currentAccountTimeZone={REPORTING_TIMEZONE}
            onSubmitModalState={onSubmitOpenFilterModal}
            onClickModalClose={onCloseFilterModal}
            campaignOptions={campaignOptions}
            brandsOptions={brandsOptions}
            show_rtb_brand_ui_changes={show_rtb_brand_ui_changes}
          />
          {isBenepathBrand && (
            <LeadNoteModal
              modalState={leadNoteModal}
              onSubmitClick={onSubmitLeadNoteModal}
              onCloseClick={onCloseLeadNoteModal}
              textHeading="Lead Notes"
            />
          )}
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <ToolkitProvider
                    keyField="id"
                    // If we hardcode any of the field's hidden value then only customize columns works
                    columns={[{ dataField: 'dummy', hidden: true, csvExport: false }, ...sortedColumns]}
                    data={filteredLeads.map(lead => {
                      const receipts = lead?.receipts || [];
                      const sum = getCostFromLeadReceipts(receipts, lead?.created_at, isReceiptTypeIdDebitActual);
                      const refund_status = getLeadRedundStatus(lead?.lead_refund?.status, lead?.lead_refund?.created_at);

                      return {
                        ...lead,
                        price: sum.toFixed(2),
                        refund_status: refund_status ? capitalizeFirstLetter(refund_status.toLowerCase()) : null
                      }
                    })}
                    search
                    exportCSV={{
                      fileName: "Leads.csv",
                      exportAll: false,
                    }}
                  >
                    {toolkitProps => (
                      <>
                        {(() => {
                          const offsetLookAheadPages = 8
                          const currentPage = Math.max(1, Number(last_page_fetched) || 1)
                          const knownTotalPages = Math.max(Number(total_number_of_pages) || 0, currentPage)
                          const paginationTotal = knownTotalPages > 0
                            ? knownTotalPages
                            : (has_next_page
                              ? currentPage + (has_lookahead_pages ? offsetLookAheadPages : 1)
                              : currentPage)
                          return (
                            <>
                        <Row className="">
                          <Col md="auto" className="align-self-end">
                            <FormGroup className="mt-1 mb-0">
                              <div>
                                <button
                                  className={`d-flex align-items-center btn btn-outline-primary ${(filterModal?.isActiveModal || filterCheckedCount !== 0) ? 'filter-btn' : ''} ${filterCount === 0 ? 'filter-btn-w' : ''}`}
                                  type='button'
                                  onClick={onClickOpenFilterModal}
                                >
                                  <i className="bx bx-filter font-size-18 align-middle me-2" />
                                  Filters {filterCount != 0 && <span className={filterModal?.isActiveModal ?
                                    'numberCircle' : 'numberCircle border-0'}> {filterCount} </span>}
                                </button>
                              </div>
                            </FormGroup>
                          </Col>
                          <Col xl="auto" className="align-self-center">
                            <div className="d-flex flex-wrap align-items-center">
                              {filteredColumns && filteredColumns.map((single_object, idx) => (
                                <div key={idx} className={`mx-2 mb-1 ${UserStyle.selected_filter}`}>
                                  <div className="d-flex align-items-center">
                                    <span>{single_object?.name} : <b>{single_object?.value}</b></span>
                                    <a className={`ms-2 ${getPrimaryTextClass()} font-size-18`} onClick={() => onClickRemoveFilter(single_object?.fieldName)} style={{ cursor: "pointer" }}>
                                      <span aria-hidden="true">&times;</span>
                                    </a>
                                  </div>
                                </div>
                              ))
                              }
                            </div>
                          </Col>
                          <Col xl="auto" className="ms-auto align-self-end">
                            <div className="d-flex flex-row gap-2">
                              <div>
                                <FormGroup className="align-self-end">
                                  <div>
                                    <CustomExportCSVButton
                                      className="btn btn-outline-sfblue"
                                      applyCustomOnClick={true}
                                      onClick={handleAnalyticsDataExport}
                                      {...toolkitProps.csvProps}
                                    >
                                      <i className="bx bx-import font-size-14 align-middle me-2" />
                                      {export_email_loading ? "Please Wait..." : "Export"}
                                    </CustomExportCSVButton>
                                  </div>
                                </FormGroup>
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <Row id="leads-table" className="sfTable-Container table-responsive">
                          <Col xl="12">
                            {!filteredLeads?.length && (get_leads_loading || user_column_preference_lead_loading) ? (
                              <SfLoadingSkeleton rows={5} cols={8} />
                            ) : (
                              <BootstrapTable
                                keyField="id"
                                responsive
                                bordered={false}
                                striped={false}
                                rowEvents={rowEvents}
                                rowClasses="tr-hover"
                                filter={filterFactory()}
                                classes="table align-middle table-nowrap text-black"
                                headerClasses="sftableHeader thead-h50 text-black"
                                headerWrapperClasses="thead-light"
                                noDataIndication="You currently don't have any leads"
                                remote={backendSortingEnabled ? { pagination: false, filter: false, sort: true } : false}
                                onTableChange={handleTableChange}
                                sort={{
                                  sortCaret: customSortCaret,
                                  ...(backendSortingEnabled && { dataField: sortState.column, order: sortState.direction }),
                                }}
                                {...toolkitProps.baseProps}
                              />
                            )}
                          </Col>
                        </Row>
                        {shouldUseOffsetPagination ? (
                          <OffsetPagination
                            currentPage={currentPage}
                            totalPages={paginationTotal}
                            hasNextPage={has_next_page}
                            hasDeepOffsetPages={has_lookahead_pages}
                            offsetLookAheadPages={offsetLookAheadPages}
                            loading={get_leads_loading}
                            onPageChange={(page) => fetchLeadsPage(page, filterCheckedCount > 0 ? activeFilteredColumnsState : null)}
                            className="campaign-analysis-pagination mt-3 align-items-center justify-content-end"
                          />
                        ) : isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_REMOVE_TOTAL_NUMBER_OF_PAGES) ?
                          <Row>
                            <Col xl='auto' className='ms-auto'>
                              {has_next_page && <button className='btn btn-outline-sfblue'
                                onClick={() => fetchLeadsPage(last_page_fetched + 1, filterCheckedCount > 0 ? activeFilteredColumnsState : null)}>{get_leads_loading ? 'Please wait...' : 'Load More'}</button>}
                            </Col>
                          </Row>
                          :
                          <Row>
                            {!get_leads_loading && <Col xl='auto'>
                              {last_page_fetched} out of {total_number_of_pages} page(s)
                            </Col>}
                            <Col xl='auto' className='ms-auto'>
                              {last_page_fetched < total_number_of_pages && <button className='btn btn-outline-sfblue'
                                onClick={() => fetchLeadsPage(last_page_fetched + 1, filterCheckedCount > 0 ? activeFilteredColumnsState : null)}>{get_leads_loading ? 'Please wait...' : 'Load More'}</button>}
                            </Col>
                          </Row>
                        }
                            </>
                          )
                        })()}
                      </>
                    )}
                  </ToolkitProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  )
}

export default Leads
